// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__U8SKE","heading":"Privacy_heading__tvlGU","policy":"Privacy_policy__UgmXu","subHeading":"Privacy_subHeading__LU+FC","content":"Privacy_content__TqQul"};